import React from 'react';
import styled from 'styled-components';
import { MIDNIGHT_BLUE, CERULEAN } from '../@style/colors';
import screens from '../@style/screens';

interface Props extends React.HTMLAttributes<HTMLDivElement> {
  label: string;
  disabled: boolean;
}

type WrapperProps = Pick<Props, 'disabled'>;

const SubmitWrapper = styled.button.attrs({ type: 'submit' })<WrapperProps>`
  background-color: ${MIDNIGHT_BLUE};
  width: 90%;
  height: 65px;
  margin: 30px 0;
  border: 2px solid ${CERULEAN};
  border-radius: 35px;
  cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'pointer')};
  padding: 0 50px;
  opacity: ${({ disabled }) => (disabled ? 0.5 : 1)};
  &:hover {
    background-color: ${({ disabled }) => (disabled ? MIDNIGHT_BLUE : CERULEAN)};
  }
  align-self: center;
  @media ${screens.laptop} {
    width: 400px;
  }
`;

const Label = styled.h4`
  color: white;
  font-size: 17px;
  margin: auto;
  font-weight: bold;
  @media ${screens.laptop} {
    font-size: 26px;
  }
`;

const SubmitButton: React.FC<Props> = ({ label, disabled }) => {
  return (
    <SubmitWrapper disabled={disabled}>
      <Label>{label}</Label>
    </SubmitWrapper>
  );
};

export default SubmitButton;
